import React from 'react';

const CaseSealedLabel = ({ sealed, className }) => {
	return sealed ? <div className={`badge bg-danger ${className}`}>SEALED</div> : <></>;
};

export default CaseSealedLabel;
